/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Payments_TypeInputs */

const en_settings_payments_type = /** @type {(inputs: Settings_Payments_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type`)
};

const zh_settings_payments_type = /** @type {(inputs: Settings_Payments_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`类型`)
};

/**
* | output |
* | --- |
* | "Type" |
*
* @param {Settings_Payments_TypeInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_payments_type = /** @type {((inputs?: Settings_Payments_TypeInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Payments_TypeInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_payments_type(inputs)
	return zh_settings_payments_type(inputs)
});
export { settings_payments_type as "settings.payments.type" }